import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { GlobalProvider } from "./comp/global";
import { IonApp, isPlatform } from "@ionic/react";
import {Helmet} from "react-helmet";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<>
  <Helmet>
      <title>Vaishnava Songs</title>
      <meta name="description" content="Vaishnava Songs" />
  </Helmet>
 <BrowserRouter>
  <GlobalProvider>
    <IonApp>
        <App />
   </IonApp>
  </GlobalProvider>
 </BrowserRouter>
 </>);

if(isPlatform("mobileweb") || isPlatform("desktop")){
  serviceWorkerRegistration.register();
}